import React, { useCallback, useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;
const hdr = () => ({ Authorization: `Bearer ${localStorage.getItem("reclaim_token")}`, "Content-Type": "application/json" });
const gbp = (n) => `£${Number(n || 0).toFixed(2)}`;

// Admin: switch Clone My Voice on per user + monthly cost vs £6.99 price.
export const VoiceCloneUsagePanel = () => {
  const [data, setData] = useState(null);
  const [email, setEmail] = useState("");
  const [rate, setRate] = useState("");
  const [alertGbp, setAlertGbp] = useState("");
  const [allowance, setAllowance] = useState("");
  const [msg, setMsg] = useState("");

  const load = useCallback(async () => {
    const r = await fetch(`${API}/api/admin/voice-clone/usage`, { headers: hdr() });
    if (r.ok) {
      const d = await r.json();
      setData(d); setRate(String(d.gbp_per_1k_chars)); setAlertGbp(String(d.alert_gbp)); setAllowance(String(d.monthly_chars_allowance));
    }
  }, []);
  useEffect(() => { load(); }, [load]);

  const entitle = async (em, enabled) => {
    const r = await fetch(`${API}/api/admin/voice-clone/entitle`, { method: "POST", headers: hdr(), body: JSON.stringify({ email: em, enabled }) });
    setMsg(r.ok ? `${enabled ? "Enabled" : "Disabled"} cloning for ${em}` : "User not found");
    if (r.ok) { setEmail(""); load(); }
  };
  const saveRate = async () => {
    await fetch(`${API}/api/admin/voice-clone/rate`, { method: "POST", headers: hdr(), body: JSON.stringify({ gbp_per_1k_chars: Number(rate), alert_gbp: Number(alertGbp), monthly_chars_allowance: Number(allowance) }) });
    setMsg("Settings saved");
    load();
  };

  return (
    <div className="bg-white border border-slate-200 rounded-xl p-5 mb-8" data-testid="voice-clone-usage-panel">
      <h2 className="text-base font-semibold text-slate-900 mb-1">Cloning users &amp; cost monitor</h2>
      <p className="text-xs text-slate-500 mb-4">This month's ElevenLabs characters spoken in each user's cloned voice, against the {gbp(data?.price_gbp)} / month price.</p>
      <div className="flex flex-wrap gap-2 mb-3">
        <input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="user@email.com" data-testid="voice-clone-entitle-email"
          className="flex-1 min-w-[200px] border border-slate-300 rounded-lg px-3 py-2 text-sm" />
        <button onClick={() => email.trim() && entitle(email.trim(), true)} data-testid="voice-clone-entitle-btn"
          className="px-4 py-2 rounded-lg bg-slate-900 text-white text-sm">Enable cloning</button>
      </div>
      <div className="flex flex-wrap items-center gap-x-4 gap-y-2 mb-4 text-xs text-slate-600">
        <label className="flex items-center gap-1.5">Cost £ / 1k chars
          <input value={rate} onChange={(e) => setRate(e.target.value)} className="w-16 border border-slate-300 rounded px-2 py-1" data-testid="voice-clone-rate-input" /></label>
        <label className="flex items-center gap-1.5">Email alert at £
          <input value={alertGbp} onChange={(e) => setAlertGbp(e.target.value)} className="w-16 border border-slate-300 rounded px-2 py-1" data-testid="voice-clone-alert-input" /></label>
        <label className="flex items-center gap-1.5">Monthly allowance (chars)
          <input value={allowance} onChange={(e) => setAllowance(e.target.value)} className="w-24 border border-slate-300 rounded px-2 py-1" data-testid="voice-clone-allowance-input" /></label>
        <button onClick={saveRate} className="underline" data-testid="voice-clone-rate-save">Save</button>
      </div>
      {msg && <p className="text-xs text-emerald-700 mb-3" data-testid="voice-clone-entitle-msg">{msg}</p>}
      <div className="overflow-x-auto">
        <table className="w-full text-sm" data-testid="voice-clone-usage-table">
          <thead><tr className="text-left text-xs text-slate-500 border-b">
            <th className="py-2 pr-3">User</th><th className="pr-3">Plan</th><th className="pr-3">Voice</th><th className="pr-3">Renders</th><th className="pr-3">Chars</th><th className="pr-3">Cost</th><th className="pr-3">Margin</th><th />
          </tr></thead>
          <tbody>
            {(data?.items || []).map((u) => (
              <tr key={u.email} className="border-b last:border-0" data-testid={`voice-clone-usage-row-${u.email}`}>
                <td className="py-2 pr-3">{u.name || u.email}<div className="text-xs text-slate-400">{u.email}</div></td>
                <td className="pr-3 capitalize">{u.plan}</td>
                <td className="pr-3 capitalize">{u.status}</td>
                <td className="pr-3">{u.renders_month}</td>
                <td className="pr-3">{u.chars_month.toLocaleString()}<div className="text-xs text-slate-400">{u.allowance_pct ?? 0}% of allowance</div></td>
                <td className="pr-3">{gbp(u.cost_month_gbp)}</td>
                <td className={`pr-3 font-medium ${u.margin_month_gbp < 0 ? "text-red-600" : "text-emerald-700"}`}>{gbp(u.margin_month_gbp)}</td>
                <td><button onClick={() => entitle(u.email, false)} className="text-xs text-slate-400 underline" data-testid={`voice-clone-disable-${u.email}`}>Disable</button></td>
              </tr>
            ))}
            {data && !data.items.length && <tr><td colSpan={8} className="py-3 text-xs text-slate-400">No users have cloning enabled yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
};
